import { IIconsProps } from "./icons.model";

const CaixaIcon = (props: IIconsProps) => {
  return (
    <img
      id={props.id}
      src={"/icon/caixa/caixa.svg"}
      alt=""
      style={{ width: props.fontSize, height: props.fontSize }}
    />
  );
};

export default CaixaIcon;
